var map = {
	"./credit-card-icons.svg": "6c29",
	"./flower-market.svg": "837b",
	"./general_flower.svg": "f00e",
	"./icon_App-Store.svg": "c4a2",
	"./icon_Google-Play.png": "7249",
	"./icon_Windows-Store.png": "6a71",
	"./shopping-bag.svg": "38f3",
	"./user-regular.svg": "2bdc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";